// extracted by mini-css-extract-plugin
export default {"title":"RetainedEarningSchedule_title__ljCwi"};